<template>
    <div class="contentDetail">
        <div class="tab borderBot borderBotLeft0">
            <div class="item" :class="{'active': act === 1}" @click="act = 1">商品介绍</div>
        </div>
        <div class="content" v-html="detail">
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            act: 1
        }
    },
    props: {
        detail: {
            type: String,
            default: () => {
                return ''
            }
        },
        specifications: {
            type: Array,
            default: () => {
                return []
            }
        }
    }
}
</script>
<style lang='scss' scoped>
    .tab {
        display: flex;
        justify-content: space-around;
        height: 88px;
        line-height: 88px;
        position: relative;
        .item {
            width: 50%;
            text-align: center;
            &.active {
                color: #ff7a45;
                border-bottom: 4px solid #ff7a45;
            }
        }
    }
    .content {
        text-align: center;
    }
    .contentDetail {
        background: #ffffff;
    }
    .content2 {
        padding: 32px;
        line-height: 48px;
        color: #666666;
        font-size: 28px;
        img {
            width: auto;
            height: auto;
        }
    }
</style>